/**
 * Sets the `value` at the given `path.
 * It makes a copy of all the objects encountered along the way.
 * @param {string} key
 * @param {Object} message
 * @param {Object} [data={}]
 */
export default function createValidationElementUtil (key, message, data = {}) {
  return {
    key,
    message,
    data
  }
}
